import React from 'react';
import '../../assets/css/App.css';
import Header from "../../features/Layout/Header";
import Footer from "../../features/Layout/Footer";
import { withTranslation } from 'react-i18next';

class Terms extends React.Component {
    render() {
        const { t } = this.props;
        return(
            <div className="App Terms">
                <Header  hide='true' hideSearch={true} />
                <main>
                    <h1>{t('pages.terms.title')}</h1>
                    <p dangerouslySetInnerHTML={{ __html: t('pages.terms.content') }} />
                </main>
                <Footer />
            </div>
        );
    }
}

export default withTranslation()(Terms);
